import type { FetchMetadataProps } from '../createMetadataFetcher';
import { createMetadataFetcher } from '../createMetadataFetcher';
import { getOrigin } from '../getOrigin';

// https://icecast.org/docs/icecast-latest/server-stats.html
interface IcestatsMetadata {
  icestats: {
    audio_bitrate?: string;
    audio_channels?: string;
    audio_samplerate?: string;
    frame_rate?: string;
    frame_size?: string;
    genre?: string;
    ice_bitrate?: string;
    listener_peak?: string;
    listeners?: string;
    listenurl?: string;
    max_listeners?: string;
    public?: string;
    server_description?: string;
    server_name?: string;
    server_type?: string;
    slow_listeners?: string;
    source_ip?: string;
    subtype?: string;
    title?: string;
    total_bytes_read?: string;
    total_bytes_sent?: string;
    user_agent?: string;
    video_bitrate?: string;
    video_quality?: string;
  };
}

export const fetchIcestats = async ({
  url,
  ...forwardingProps
}: FetchMetadataProps) => {
  return createMetadataFetcher({
    ...forwardingProps,
    url: `${getOrigin(url)}/status-json.xsl`,
    parser: async (response) => {
      const { icestats }: IcestatsMetadata = await response.json();
      const { title } = icestats ?? {};

      return title;
    }
  });
};
